function waitForElement(querySelector, timeout) {
  return new Promise((resolve, reject) => {
    var timer = false;
    if (document.querySelectorAll(querySelector).length) return resolve();
    const observer = new MutationObserver(() => {
      if (document.querySelectorAll(querySelector).length) {
        observer.disconnect();
        if (timer !== false) clearTimeout(timer);
        return resolve();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    if (timeout)
      timer = setTimeout(() => {
        observer.disconnect();
        reject();
      }, timeout);
  });
}

function moveCurrencySelector() {
  const currencySelector = document.querySelector(".pick_currency.mldesk");
  const mobileTarget = document.querySelector(
    ".mobile-customer-link.nav-mb-footer-main"
  );
  const desktopTarget = document.querySelector(".main-icons-with-locale");

  if (window.innerWidth < 768) {
    mobileTarget.appendChild(currencySelector);
  } else {
    desktopTarget.appendChild(currencySelector);
  }

  currencySelector.classList.add("transformZ");
}

waitForElement(".pick_currency.mldesk", 3000).then(() => {
  setTimeout(() => {
    moveCurrencySelector();
  });
});

window.addEventListener("resize", function () {
  moveCurrencySelector();
});
